import React, { useEffect, useState } from 'react';
import ApiService from '../../models/ApiService';

const ShayariOfTheDay = () => {

    const [shayari, setShayari] = useState({
        urdu: "",
        roman: "",
        devnagari: "",
        poet: "",
        poet_urdu: "",
        poet_hindi: "",

    });

    useEffect(() => {
        fetchSher();
    }, []);

    const fetchSher = async () => {
        try {
            const res = await ApiService.RandomSher();
            const responseContent = res.data.responseContent
            console.log(res);


            setShayari({
                urdu: responseContent.urdu || "",
                roman: responseContent.roman || "",
                devnagari: responseContent.devnagari || "",
                poet: responseContent.poet || "",
                poet_urdu: responseContent.poet_urdu || "",
                poet_hindi: responseContent.poet_hindi || "",
            });
        } catch (error) {
            console.error("Error fetching sher:", error);
        }
    };

    return (
        <div className="bg-[--header-color-g] p-4 rounded-2xl shadow-lg" id='primary-fonts'>
            <div className="flex items-start justify-between mb-4">
                <div>
                    <h2 className="text-2xl font-bold text-[--text-color] flex items-center gap-2">
                        she'r of the Day
                    </h2>
                </div>
            </div>

            {/* Urdu Shayari */}
            <div className="bg-white/10 p-4 rounded-xl mb-4 shadow-inner border border-white/10">
                <p
                    className="text-xl text-white leading-loose text-right"
                    id='primary-urdu-fonts'
                    style={{ direction: 'rtl' }}
                    dangerouslySetInnerHTML={{ __html: shayari.urdu.replace(/\n/g, '<br />') }}
                ></p>

                <p
                    className="text-xl text-[--text-color] leading-loose text-right"
                    id='primary-urdu-fonts'
                    style={{ direction: 'rtl' }}
                >
                    {shayari.poet_urdu}
                </p>

                {/* Devanagari Shayari */}
                <p
                    className="text-xl font-medium text-white leading-relaxed whitespace-pre-line font-devnagri mt-2"
                    style={{ direction: 'ltr' }}
                >
                    {shayari.devnagari}
                </p>
                <p
                    className="text-xl text-[--text-color] leading-loose text-left"
                >
                    {shayari.poet_hindi}
                </p>

                {/* Roman  */}
                <p className="text-lg text-white leading-relaxed italic mt-2"
                    dangerouslySetInnerHTML={{ __html: shayari.roman.replace(/\n/g, '<br />') }}
                >
                </p>
            </div>

            {/* Poet */}
            <div className="text-left mt-4">
                <p className="text-sm text-[--text-color] font-semibold italic">
                     {shayari.poet}
                </p>
            </div>
        </div>
    );
};

export default ShayariOfTheDay;
